"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAsync = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _useMemoizedFn = _interopRequireDefault(require("./useMemoizedFn"));

var useAsync = function useAsync(asyncFn) {
  var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  // four status to choose ["idle", "pending", "success", "error"]
  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var fetchFn = (0, _useMemoizedFn["default"])(asyncFn);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var _useState7 = (0, _react.useState)('idle'),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      status = _useState8[0],
      setStatus = _useState8[1]; // return the memoized function
  // useCallback ensures the below useEffect is not called
  // on every render, but only if asyncFunction changes.


  var refetch = (0, _react.useCallback)(function () {
    // reset the state before call
    setStatus('pending');
    setData(undefined);
    setLoading(true);
    return fetchFn().then(function (response) {
      setData(response);
      setStatus('success');
      setError(null);
      return response;
    })["catch"](function (error) {
      setData(undefined);
      setStatus('error');
      setError(error);
    })["finally"](function () {
      setLoading(false);
    });
  }, [fetchFn]); // execute the function
  // if asked for immediate

  (0, _react.useEffect)(function () {
    if (immediate) {
      refetch();
    }
  }, [refetch, immediate]);
  return {
    refetch: refetch,
    status: status,
    data: data,
    error: error,
    loading: loading
  };
};

exports.useAsync = useAsync;